// @flow

import React from "react";

import { useModal, OkButton, WarningModalIcon } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import { Modal, bindModal } from "../comum";

import "./modal-erro.css";

const ModalErro = () => {
  const modal = useModal("ModalErro");

  return (
    <Modal transition mountOnShow className="ModalErro" {...bindModal(modal)}>
      <Modal.Header closeButton />

      <Modal.Body>
        <div className="ModalErro__mensagem">
          <WarningModalIcon />
          <div className="ModalErro__erros">
            {(modal.props.erros || []).map((erro, index) => (
              <div key={index} className="ModalErro__erro">
                {erro}
              </div>
            ))}
          </div>
        </div>

        <div className="ModalErro__rodape">
          <OkButton className="ModalErro__botao" onClick={modal.close}>
            <Translate>configuracaoRelatorio.botaoOk</Translate>
          </OkButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalErro;
